// Barrel that side-effect-loads the legacy upFilters engine (WEB-8020). upListFilters
// registers ReactTemplates.upFilters.filterMenu and the namespace; each filters/*.jsx
// populates ReactTemplates.upFilters.components / .filterTypes at module eval. Loaded
// once by ReactTemplatesShim at the React entry (order: engine first, then filters).
import './upListFilters';
import './filters/address';
import './filters/date';
import './filters/datePreset';
import './filters/idList';
import './filters/list';
import './filters/listLazy';
import './filters/listLeadSource';
import './filters/listRow';
import './filters/listShort';
import './filters/listShortSingle';
import './filters/radio';
import './filters/radioSearch';
import './filters/range';
import './filters/socialEvent';
import './filters/tabPage';
import './filters/text';
import './filters/time';
import './filters/visitRow';
import './filters/history/activityOnlyPage';
import './filters/history/activityPage';
import './filters/history/history';
import './filters/history/opportunityPage';
import './filters/history/orderPage';
import './filters/history/taskPage';
